import React from 'react'
import MaterialTable from '@material-table/core'
import * as UIcons from '@iconscout/react-unicons'
import { useDispatch, useSelector } from 'react-redux'
import { getResponse, previewModal, showModal } from 'store/slices/miscSlice'
import { withTranslation } from 'react-i18next'
import HeaderComponent from 'components/HeaderComponent'
import Btn from 'components/Btn'
import AddRole from './AddRole'
import { RoleValidation } from 'pages/Settings/validation'
// import TableActionBtn from 'components/TableActionBtn'
import Icons from 'includes/Icons'
import useRole from 'hooks/useRole'
import Spinner from 'components/Spinner'
import { useEffect } from 'react'
import { mutate } from 'swr'
// import useSWR from 'swr'


export default withTranslation()(function RolesTable({ t }) {
  // const {data: roles} = useSWR('user-mgmt/roles')
  const { roles } = useRole()
  const dispatch = useDispatch()

  const { response } = useSelector(state => state?.misc)
  useEffect(() => {
    mutate('user-mgmt/roles')
  }, [response])

  return (
    <>
      {
        <div className="bg-white rounded-xl mb-10 overflow-hidden p-5">
          {
            roles ? <MaterialTable
              title=''
              columns={[
                { title: 'Name', field: 'name' },
                { title: 'Display name', field: 'display_name' },
              ]}
              options={{
                actionsColumnIndex: -1
              }}
              actions={[
                {
                  icon: () => <UIcons.UilEye className="text-primary" />,
                  tooltip: 'View details',
                  onClick: (e, tableProps) => dispatch(previewModal({
                    title: 'User details',
                    // content: () => <UserPreview tableProps={tableProps} />
                  }))
                }
              ]}
              data={roles ?? []}
              icons={Icons}
              components={{
                Toolbar: props => (
                  <>
                    <HeaderComponent
                      title="Roles management"
                      btnText={t('settings.role_management.add_role')}
                      btnClick={() => {
                        dispatch(showModal({
                          title: t('settings.role_management.add_role'),
                          content: AddRole,
                          validation: RoleValidation,
                          method: 'post',
                          url: 'user-mgmt/roles',
                          successMsg: t('settings.role_management.success_msg'),
                        }))
                      }}
                    />
                  </>
                ),
                Action: ({ data }) => (
                  <div className="flex">
                    {/* <div className="bg-primary rounded-lg overflow-hidden w-8 h-8"> */}
                    <Btn
                      className="w-8 h-8 p-0 rounded-lg overflow-hidden bg-primary mr-2"
                      content={() => <UIcons.UilPen size={16} className="text-white" />}
                      click={() => {
                        dispatch(
                          showModal(
                            {
                              title: t('settings.role_management.edit'),
                              content: AddRole,
                              url: `user-mgmt/roles/${data.id}`,
                              values: {
                                name: data.name,
                                display_name: data.display_name
                              },
                              method: 'put',
                              validation: RoleValidation,
                              successMsg: t('settings.role_management.edit_msg')
                            }
                          )
                        );
                        dispatch(getResponse(`edit_role_${data.id}`))
                      }
                      }
                    />

                    <Btn
                      className="w-8 h-8 p-0 rounded-lg overflow-hidden bg-[#FF3B30]"
                      content={() => <UIcons.UilTrash size={16} className="text-white" />}
                      click={() => {
                        dispatch(
                          showModal(
                            {
                              title: t('settings.role_management.delete'),
                              content: () => <div className="text-md w-full text-center">

                                {/* <Trans i18nKey="confirm_action" name="role">
                          You have triggered a <strong className="font-medium text-red-400">delete</strong> action, do you wish to continue with the deletion?
                        </Trans> */}

                              </div>,
                              url: `user-mgmt/roles/${data.id}`,
                              method: 'delete',
                              btnText: 'Continue',
                              disableBtn: false,
                              successMsg: t('settings.role_management.delete_msg')
                            }
                          )
                        );
                        dispatch(getResponse(`delete_role_${data.id}`))
                      }
                      }
                    />
                  </div>
                  // <TableActionBtn 
                  //   data={[
                  //     {
                  //       Content: {
                  //         icon: UIcons.UilEditAlt,
                  //         text: t('misc.edit_details')
                  //       },
                  //   action: () => dispatch(
                  //     showModal(
                  //       {
                  //         title: t('settings.role_management.edit'),
                  //         content: AddRole,
                  //         url: `user-mgmt/roles/${data.id}`,
                  //         values: {
                  //           name: data.name,
                  //           display_name: data.display_name
                  //         },
                  //         method: 'put',
                  //         validation: RoleValidation,
                  //         successMsg: t('settings.role_management.edit_msg')
                  //       }
                  //     )
                  //   ) 
                  // },
                  //     {
                  //       Content: {
                  //         icon: UIcons.UilTrash,
                  //         text: t('misc.delete'),
                  //         classList: 'text-failure'
                  //       },
                  //   action: () => dispatch(
                  //     showModal(
                  //       {
                  //         title: t('settings.role_management.delete'),
                  //         content: () => <div className="text-md w-full text-center">

                  //           <Trans i18nKey="confirm_action" name="role">
                  //             You have triggered a <strong className="font-medium text-red-400">delete</strong> action, do you wish to continue with the deletion?
                  //           </Trans>

                  //         </div>,
                  //         url: `user-mgmt/roles/${data.id}`,
                  //         method: 'delete',
                  //         btnText: 'Continue',
                  //         disableBtn: false,
                  //         successMsg: t('settings.role_management.delete_msg')
                  //       }
                  //     )
                  //   ) 
                  // }
                  //   ]}
                  // />
                )
              }}
            />
              : <Spinner />
          }

        </div>
        // )
      }
    </>
  )
})